import { render, staticRenderFns } from "./TwitterConnect.vue?vue&type=template&id=f99872e8"
import script from "./TwitterConnect.vue?vue&type=script&lang=js"
export * from "./TwitterConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports